import React from "react";
import classnames from "classnames";
import {ReactComponent as ArrowRightIcon} from "../../assets/arrow-right.svg";

import styles from "./Button.module.scss";

interface ButtonProps {
  text: string;
  secondaryText?: string;
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLButtonElement>) => Promise<void>);
  variant?: "primary" | "secondary" | "donation";
  disabled?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactChild;
  className?: string;
}

export default function Button({
  text,
  onClick,
  secondaryText,
  variant = "primary",
  disabled = false,
  style = {},
  children,
  className,
}: ButtonProps) {
  return (
    <button
      className={classnames(className, styles.button, styles[variant], { [styles.disabled]: disabled })}
      style={style}
      onClick={disabled ? () => {} : onClick}
    >
      <p className={styles.text}>
        {text}
      </p>
      <p className={styles.secondaryText}>
        {secondaryText || children ? secondaryText || children : <ArrowRightIcon className={styles.icon} />}
      </p>
    </button>
  );
}
